import type { InjectedAsset } from "@/lib/runtime-branding"

/**
 * ChatHome HelloAILogo may use injected landing logos only — never `logo_large_*`.
 * Theme fallback is the other landing slot, then the caller uses public/customer or SVG.
 */
export function resolveInjectedLandingLogo(
  landingLight: InjectedAsset | undefined,
  landingDark: InjectedAsset | undefined,
  effectiveTheme: "light" | "dark"
): InjectedAsset | undefined {
  return effectiveTheme === "dark" ? (landingDark ?? landingLight) : (landingLight ?? landingDark)
}
